export const SHOULD_NOT_OPEN_SAVED_SEARCHES_STORAGE_KEY = "si:advanced-search:should-not-open-quick-searches";
